// PartnershipFirmRegistration.jsx
import React from "react";

export default function PartnershipFirmRegistration() {
  const handleWhatsAppClick = () => {
    const phoneNumber = "919217468906"; // without +
    const message =
      "Hello! I would like to get a consultation for Partnership Firm Registration.";
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(url, "_blank");
  };

  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Partnership Firm
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Partnership Firm Registration in India
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks provides dedicated support for Partnership Firm
            Registration, ensuring that your business is structured correctly
            from day one. The team helps you with drafting, reviewing, and
            aligning the partnership deed with applicable legal requirements.
          </p>
          <p className="text-gray-700">
            From defining partner roles and profit-sharing ratios to completing
            documentation and registration formalities, Hawkins &amp; Brooks
            streamlines the process so partners can focus on running and growing
            their venture.
          </p>
        </div>

        {/* Right: Image */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/3184418/pexels-photo-3184418.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Team discussing partnership firm registration"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for Partnership Firm Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks offers professional assistance in collating,
              verifying, and organizing all documents needed for partnership
              firm setup, helping avoid errors and re-submissions.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>PAN card of all partners</li>
                <li>Identity proof of partners (Aadhaar, Passport, etc.)</li>
                <li>Address proof of partners</li>
                <li>Duly drafted and executed partnership deed</li>
                <li>Proof of office/firm address (rent agreement, utility bill, etc.)</li>
                <li>Passport-size photographs of partners</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm blends legal insight with practical business experience
              to ensure your partnership is clearly structured and future-ready.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Clear Legal Structuring
                </h3>
                <p className="text-gray-700 text-sm">
                  Guidance on capital contribution, roles, responsibilities, and
                  rights of partners to minimize future disputes and ambiguities.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Deed Drafting Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Assistance in preparing a comprehensive partnership deed
                  covering profit-sharing, admission and retirement of partners,
                  decision-making, and dissolution clauses.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Professional Compliance Advisory
                </h3>
                <p className="text-gray-700 text-sm">
                  Advisory on registration options, tax implications, and
                  ongoing compliances to keep your partnership aligned with
                  regulatory requirements.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <button
                type="button"
                onClick={handleWhatsAppClick}
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </button>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
